import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue";
import {
  ApprovalSearchRequest,
  ApprovalShiftRequest
} from "@/models/approval/ApprovalRequest";
import { ApprovalShiftResponse } from "@/models/approval/ApprovalResponse";
import ApprovalTableBase, { HeaderType } from "./ApprovalTableBase.vue";
import { Paths } from "@/plugins/api/paths";
import { $alert } from "@/plugins/alert/alert";
import { $post } from "@/plugins/api/api";
import { $confirm } from "@/plugins/confirm/confirm";
import { useApproval } from "@/composable/Approval";
import ShiftDialog from "../form/ShiftDialog.vue";
import ShiftExpandItem from "../expand/ShiftExpandItem.vue";
import Vuex from "@/store/index";
import { Authority } from "@/models/enum/Enum";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeShiftTable',
  setup(__props) {

const approval = useApproval();

const header: HeaderType = {
  key: "recordId",
  date: "date",
  user: "employeeName",
  affiliation: "affiliationName",
  approval: "approvalState"
};

const title = "シフト申請承認";

const selected = ref<ApprovalShiftResponse[]>([]);
const items = ref<ApprovalShiftResponse[]>([]);
const form = ref<ApprovalSearchRequest>(approval.getForm());

const isDisabled = computed(() => {
  const authority = Vuex.state.authority;
  return authority < Authority.Accountant;
});

const getItems = async (request: ApprovalShiftRequest) => {
  const response = await $post<ApprovalShiftResponse[]>(
    Paths.approval.shift.search,
    request
  );
  if (response) items.value = response;
};

const onSearch = async () => {
  await getItems(form.value);
};

const onResolve = async (
  items: ApprovalShiftResponse[],
  selected: ApprovalShiftResponse[]
) => {
  const message = `${items.length}件承認します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.shift.resolve, items);
  if (result && typeof result === "string" && !Number.isNaN(result)) {
    $alert("error", `${result}`);
    return;
  }
  if (result) $alert("success", `${result}件承認しました。`);
  await onSearch();
  console.log("selected", selected);
  selected = [];
};
const onReject = async (
  items: ApprovalShiftResponse[],
  selected: ApprovalShiftResponse[]
) => {
  const message = `${items.length}件却下します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.shift.reject, items);
  if (result) $alert("success", `${result}件却下しました。`);
  await onSearch();
  console.log("selected", selected);
  selected = [];
};

const onCancel = async (
  item: ApprovalShiftResponse,
  selected: ApprovalShiftResponse[]
) => {
  const message = "承認を取り消します。\nよろしいですか？";
  if (!(await $confirm(message))) return;

  const result = await $post(`${Paths.approval.shift.cancel}/${item.recordId}`);
  if (result) {
    $alert("success", "取消に成功しました。");
    await onSearch();
    console.log("selected", selected);
    selected = [];
  }
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,approval, header, title, selected, items, form, isDisabled, getItems, onSearch, onResolve, onReject, onCancel, ApprovalTableBase, ShiftDialog, ShiftExpandItem }
}

})